module.exports = __webpack_public_path__ + "img/logo-touming.ce0f2c4c.png";